export default "__VITE_ASSET__DMdyAytL__"